import React from 'react';
import './AccordionImageButton.css';

function AccordionImageButton({ 
  imagePath, 
  label, 
  isExpanded, 
  onClick, 
  className = '',
  showExpandIcon = true 
}) {
  return (
    <button 
      className={`accordion-image-button ${className} ${isExpanded ? 'expanded' : ''}`}
      onClick={onClick}
    >
      <div className="accordion-image-button-content">
        {showExpandIcon && (
          <span className="accordion-icon">{isExpanded ? '▼' : '▶'}</span>
        )}
        
        <span className="accordion-image-label">{label}</span>
      </div>
    </button>
  );
}

export default AccordionImageButton;



